import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

// Reached only when the app is not installed, since installed apps intercept /app/* before the browser.
const AppLinkFallback = () => {
  const location = useLocation();
  const params = useParams();

  const target = params['*'] || '';
  const search = new URLSearchParams(location.search);
  if (target) search.set('target', target);

  const query = search.toString();
  return <Navigate replace to={query ? `/download?${query}` : '/download'} />;
};

export default AppLinkFallback;
